import { createContext, useContext, useState } from 'react';

const ReportFiltersContext = createContext(null);

export function ReportFiltersProvider({ children }) {
  const [finFilters, setFinFilters]   = useState(null);
  const [prodFilters, setProdFilters] = useState(null);
  const [crFilters, setCRFilters]     = useState(null);

  return (
    <ReportFiltersContext.Provider value={{ finFilters, setFinFilters, prodFilters, setProdFilters, crFilters, setCRFilters }}>
      {children}
    </ReportFiltersContext.Provider>
  );
}

export function useReportFilters() { return useContext(ReportFiltersContext); }
